<template>
  <footer>
    <p class="footerText">
      Copyright © {{ new Date().getFullYear() }}
      <span class="brand-text">The Video Game Vault</span>
    </p>
  </footer>
</template>